import { styled } from '@mui/styles';
import { Icon } from '@mui/material';

export const Container = styled(Icon)({
  color: 'inherit',
});
